// extracted by mini-css-extract-plugin
export default {"banner":"bulk-add-notifications-module__banner__NiDLT1Y"};